import { makeAutoObservable, runInAction } from "mobx";
import { ReportHttpRepository } from "./report_http_repository";
import { Report } from "./report_model";

export class ReportStore {
  repository = new ReportHttpRepository();
  report?: Report;
  busy = false;
  error = "";
  page = 0;
  request = 0;
  scope = "";
  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }
  async load(kind: "exams" | "students", id: string, page = 0) {
    const scope = `${kind}/${id}`;
    if (this.scope !== scope) {
      this.report = undefined;
      this.page = 0;
      this.scope = scope;
    }
    const request = ++this.request;
    this.busy = true;
    this.error = "";
    const result = await this.repository.get(kind, id, page);
    runInAction(() => {
      if (request !== this.request) return;
      this.busy = false;
      if (result.isFailure()) this.error = result.error.message;
      else {
        this.report = result.value;
        this.page = page;
      }
    });
  }
}
